// extracted by extract-css-chunks-webpack-plugin
module.exports = {"activityBanner":"activityBanner-3NgGalvx","activityBannerImg":"activityBannerImg-2Zs00saZ"};